import { RuleType } from 'helpers/form-validations';

export const validationRules = {
  type: [
    { type: RuleType.Required, message: 'This field is required' },
  ],
};
